export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_10.21837c2b.jpg";